// Import Libraries
import React, { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Collapse,
  Alert,
  Box,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// Services
import userService from '../../services/userService';
import dictionaryService from '../../services/dictionaryService';

const AboutUs = ({ userDetails }) => {
  const [error, setError] = useState(null);
  const [showSaved, setShowSaved] = useState(false);
  const [aboutUsDict, setAboutUsDict] = useState([]);
  const [userData, setUserData] = useState({
    about_us: '',
    about_us_text: '',
  });

  const updateUser = async () => {
    try {
      const payload = { ...userData, id: userDetails.id };
      const userUpdate = await userService.updateProfileFields(payload);
      if (userUpdate) {
        setShowSaved(true);
        setTimeout(() => setShowSaved(false), 2000);
      }
    } catch (err) {
      setError(err?.message || 'Unable to save your preferences.');
    }
  };

  const updateAboutUs = (value) => {
    setUserData((prev) => ({ ...prev, about_us: value }));
  };

  useEffect(() => {
    const fetchData = async () => {
      const usersStoredData = await userService.getUserAboutUs(userDetails.id);
      if (usersStoredData) {
        setUserData({
          about_us: usersStoredData.about_us || '',
          about_us_text: usersStoredData.about_us_text || '',
        });
      }

      const getAboutUs = await dictionaryService.fetchDictionary('about_us');
      if (getAboutUs) {
        getAboutUs.sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0));
        setAboutUsDict(getAboutUs);
      }
    };

    if (userDetails?.id) fetchData();
  }, [userDetails]);

  return (
    <Card sx={{ minWidth: 300 }}>
      <CardHeader
        title="How did you hear about us?"
        action={
          <Stack direction="row" spacing={1} alignItems="center">
            <Collapse in={showSaved} orientation="horizontal">
              <Box sx={{ display: 'flex', alignItems: 'center', color: 'success.main' }}>
                <CheckCircleIcon />
              </Box>
            </Collapse>
            <Button variant="contained" onClick={updateUser}>
              Save
            </Button>
          </Stack>
        }
        sx={{ pb: 0 }}
      />
      <CardContent>
        <Stack spacing={2}>
          <FormControl fullWidth>
            <InputLabel id="about-us-label">Select an option</InputLabel>
            <Select
              labelId="about-us-label"
              id="about-us"
              label="Select an option"
              value={userData.about_us}
              onChange={(e) => updateAboutUs(e.target.value)}
            >
              {aboutUsDict.map((item) => {
                const value = item.dict_about_us;
                return (
                  <MenuItem key={value} value={value}>
                    {value}
                  </MenuItem>
                );
              })}
              {/* Optional empty/none choice */}
              {aboutUsDict.length === 0 && <MenuItem value="">No options available</MenuItem>}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            multiline
            minRows={4}
            placeholder="Can you give more specifics, like which social media platform or what exactly you searched for on Google? This helps us improve how we spread the word about our service."
            value={userData.about_us_text}
            onChange={(e) => setUserData((prev) => ({ ...prev, about_us_text: e.target.value }))}
          />

          <Collapse in={!!error}>
            <Alert severity="error" onClose={() => setError(null)}>
              {error}
            </Alert>
          </Collapse>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default AboutUs;
